// extracted by mini-css-extract-plugin
module.exports =  {"dataviz-tooltip":"Tooltip-component-module__dataviz-tooltip___bFIpn","dataviz-tooltip__title":"Tooltip-component-module__dataviz-tooltip__title___Msvsk"};